'use client';

import { useEffect } from 'react';

// HACK: Navigation links on Safari don't fully scroll up (only on ironhack.com)
// This will attempt to scroll up again after a very short timeout.
export const NavigationScrollHack = (): null => {
  useEffect(() => {
    const timer = window.setTimeout(() => {
      window.scrollTo(0, 0);
    }, 50);

    return () => {
      window.clearTimeout(timer);
    };
  }, []);

  return null;
};
